import { render, staticRenderFns } from "./ApplicationRequests.vue?vue&type=template&id=6f8c303c&"
import script from "./ApplicationRequests.vue?vue&type=script&lang=js&"
export * from "./ApplicationRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports